import { Component, OnInit, ViewChild } from '@angular/core';
import { RenewalOtherOccupantForm } from '../../models/renewal-other-occupant-form';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { RenewalCogService } from 'services/renewalcog.service';
import { PetType } from '../../models/pettype';
import { RenewalPet } from '../../models/renewal-pet';
import { RenewalOtherOccupant } from '../../models/renewal-other-occupant';
import { ErrorService } from '../../../services/error.service'
import { LabelValue } from 'app/models/labelvalue';

@Component({
  selector: 'app-other-occupant-cog',
  templateUrl: './other-occupant-cog.component.html',
  styleUrls: ['./other-occupant-cog.component.css']
})

export class OtherOccupantCogComponent implements OnInit {

  model: RenewalOtherOccupantForm;
  petTypes: LabelValue[];
  hasOtherOccupantOptions: LabelValue[];
  hasPetOptions: LabelValue[];
  occupantBirthYears: LabelValue[];
  residents: LabelValue[] = [];

  @ViewChild('otherOccupantInfoForm', { static: true })
  otherOccupantInfoForm: NgForm;

  constructor(
    private renewalService: RenewalCogService, private errorService: ErrorService,
    public router: Router
  ) {
    this.model = new RenewalOtherOccupantForm();

    const RenewalKey = localStorage.getItem('RenewalKey');

    if (RenewalKey !== undefined && RenewalKey !== null) {

      this.model.LeaseRenewalKey = Number(RenewalKey);

      this.renewalService.getOtherOccupantFormInfo(this.model)
        .subscribe(res => this.getOtherOccupantFormInfo(res), err => this.errorService.showError(err));

    } else {
      this.errorService.showError("Error - unable to verify renewal key.");
    }
  }

  ngOnInit() {
    this.getHasChildrenOptions();
    this.getHasPetOptions();
    this.getOccupantBirthYears();
    this.renewalService.getRentalPetTypesRenewal(this.model.LeaseRenewalKey).subscribe(res => this.getPetTypes(res), err => this.errorService.showError("Error pulling rental pet types."));
  }

  getOccupantBirthYears() {
    const year = new Date().getFullYear();
    this.occupantBirthYears = [];
    for (let _y = year; _y >= year - 18; _y--) {
      this.occupantBirthYears.push({ label: _y.toString(), value: _y });
    }
  }

  getHasChildrenOptions() {
    this.hasOtherOccupantOptions = [];
    this.hasOtherOccupantOptions.push({ label: "Will you have children in the home?", value: null })
    this.hasOtherOccupantOptions.push({ label: "Yes", value: true });
    this.hasOtherOccupantOptions.push({ label: "No", value: false });
  }

  getHasPetOptions() {
    this.hasPetOptions = [];
    this.hasPetOptions.push({ label: "Do you have any pets?", value: null })
    this.hasPetOptions.push({ label: "Yes", value: true });
    this.hasPetOptions.push({ label: "No", value: false });
  }

  getPetTypes(types: PetType[]) {
    this.petTypes = [];
    for (const type of types) {
      this.petTypes.push({ label: type.Title, value: type.RentalPetTypesKey });
    }
  }

  forceAtLeastOneOccupant() {
    if (this.model.HasOtherOccupants) {
      if (this.model.OtherOccupants.length === 0) {
        this.model.OtherOccupants.push(new RenewalOtherOccupant());
      }
    }
  }

  forceAtLeastOnePet() {
    if (this.model.HasPets) {
      if (this.model.Pets.length === 0) {
        this.model.Pets.push(new RenewalPet());
      }
    }
  }

  async getOtherOccupantFormInfo(info: RenewalOtherOccupantForm) {
    this.model = info;
    this.getResidentOptions();
  }

  getResidentOptions() {
    this.residents = [];

    for (const res of this.model.Residents) {
      this.residents.push({ label: res.FullName, value: res.ResidentKey });
    }
  }

  onRemoveOccupantClick(occupant: RenewalOtherOccupant) {
    if (this.model.HasOtherOccupants && this.model.OtherOccupants.length == 1) {
      this.model.HasOtherOccupants = false;
    }
    else {
      const index = this.model.OtherOccupants.indexOf(occupant);
      this.model.OtherOccupants.splice(index, 1);
    }
  }

  onAddOccupantClick() {
    this.model.OtherOccupants.push(new RenewalOtherOccupant());
  }

  onAddPetClick() {
    this.model.Pets.push(new RenewalPet());
  }

  onRemovePetClick(pet: RenewalPet) {
    if (this.model.HasPets && this.model.Pets.length == 1) {
      this.model.HasPets = false;
    }
    else {
      const index = this.model.Pets.indexOf(pet);
      this.model.Pets.splice(index, 1);
    }
  }

  removeUnusedOccupantsAndPets() {
    if (this.model.OtherOccupants.length === 1) {
      if (this.model.OtherOccupants[0].Name === '' && this.model.OtherOccupants[0].BirthYear === null && !this.model.HasOtherOccupants) {
        this.onRemoveOccupantClick(this.model.OtherOccupants[0]);
      }
    }
    if (this.model.Pets.length === 1) {
      if (this.model.Pets[0].Breed === '' && this.model.Pets[0].Weight === null && this.model.Pets[0].RentalPetTypesKey === 0 && !this.model.HasPets) {
        this.onRemovePetClick(this.model.Pets[0]);
      }
    }

    this.onSubmit();
  }

  onSubmit() {
    if (!this.model.HasOtherOccupants) {
      this.model.OtherOccupants = [];
    }
    if (!this.model.HasPets) {
      this.model.Pets = [];
    }
    this.renewalService.updateOtherOccupantFormInfo(this.model)
      .subscribe(res => this.onUpdateSuccess(),
        err => this.errorService.showError(err));
  }

  onUpdateSuccess() {
    this.router.navigate(['/renewalcog/renewal-review/roommate-info']);
  }

  // Do Not Delete.  ngFor will break on add remove without.
  listTrack(o) {
    return o;
  }

}
